import React from 'react';
import {Grid} from '@material-ui/core';
import {MDBPopover, MDBPopoverBody} from 'mdbreact';
import {FastField} from 'formik';
import FormikCurrencySelector from 'gui/components/formikCurrencySelector/FormikCurrencySelector';
import FormikPriceInput from 'gui/components/formikPriceInput/FormikPriceInput';
import EditorSection from '../../../../../commons/editor/components/editorSection/EditorSection';
import {ITicketInfo} from 'data/interfaces/products';

const PriceDetails = (props: { values: Partial<ITicketInfo> }) => (
  <EditorSection title="המחיר בו נרכשו השוברים / כרטיסים">
    <Grid item xs={12} sm={2} md={1}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >
                <span>
                  <FastField
                    component={FormikCurrencySelector}
                    label="מטבע * "
                    name="currency"/>
                </span>
        <div>
          <MDBPopoverBody>
            מטבע של הכרטיס והשינוי שם
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>
    <Grid item xs={12} sm={6}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >
        <div>
          <FormikPriceInput
            label={'המחיר בו נרכשו השוברים / כרטיסים'}
            name="currentAirlineAllTicketsPrice"
           // name="valuePrice"
            currency={props.values.currency}
          />
        </div>
        <div>
          <MDBPopoverBody>
            מחיר שוק נוכחי של כל הכרטיסים יחד בש"ח נכון להיום
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>
  </EditorSection>
);

PriceDetails.defaultProps = {
  values: {},
};

export default React.memo(PriceDetails);
